bcn.fixedNotice = (function () {

  'use strict';

  function addMarginToHeader () {

    var notice = $('.js-fixed-notice');
    var noticeHeight = notice.outerHeight();

    if (notice.length) {
      $('.main-wrapper').css({'margin-top': noticeHeight});
    }

  }

  return {
    init: function () {
      addMarginToHeader();
    }
  };

})();
